import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { RatingComponent } from '../components/elements/rating/rating.component';
import { ElMarkerComponent } from '../components/elements/el-marker/el-marker.component';
import { ElDsplPercentComponent } from '../components/elements/el-dspl-percent/el-dspl-percent.component';
import { ElDivPercentComponent } from '../components/elements/el-dspl-percent/el-div-percent.component';

import { ElDropdownComponent } from '../components/elements/el-dropdown/el-dropdown.component';
import { TrendComponent } from '../components/elements/trend/trend.component';
import { AlertItemComponent } from '../components/elements/alert-item/alert-item.component';

const EL_COMPONENTS = [
    RatingComponent,
    TrendComponent,
    ElMarkerComponent,
    ElDsplPercentComponent,
    ElDivPercentComponent,
    ElDropdownComponent,
    AlertItemComponent,
];

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        TranslateModule.forChild({
            loader: {
                provide: TranslateLoader,
                useFactory: PublicHttpLoaderFactory,
                deps: [HttpClient],
            },
        }),
    ],
    declarations: [EL_COMPONENTS],
    exports: [EL_COMPONENTS],
})
export class ElementsSharedModule {}

export function PublicHttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/public/', '.json');
}
